module.exports = __webpack_public_path__ + "img/img4.25d919f9.png";